/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import EMShero from "parts/EMSHero";
import Thechallenge from "parts/Thechallenge";
import SeeAction from "parts/SeeAction";
import WhoItsFor from "parts/Whoitsfor";
import Footer from "parts/Footer";
import Theplatform from "parts/Platform";
import HowEngage from "parts/HowEngage";
import TestimonialEms from "parts/TestimonialEms";
import WhyNube from "parts/WhyNube";
import CTAEms from "parts/CTAEms";

export default class EMSPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet defer={false}>
          <title>
            Nube iO EMS | Smart Energy Management for Portfolios
          </title>
          <meta
            name="description"
            content="Nube iO's EMS gives multi-site portfolios one platform for energy data, cost tracking, compliance reporting and decision making."
          />
          <meta
            name="keywords"
            content="EMS, Smart Energy Management, Energy Management Systems, Energy Management Solutions, Energy Management Software."
          />
          <link rel="canonical" href="https://nube-io.com/ems/" />
          <meta
            property="og:title"
            content="Nube iO EMS | Smart Energy Management for Portfolios"
          />
          <meta
            property="og:description"
            content="Nube iO's EMS gives multi-site portfolios one platform for energy data, cost tracking, compliance reporting and decision making."
          />
          <meta property="og:url" content="https://nube-io.com/ems/" />
        </Helmet>
        <Header1 />
        <EMShero />
        <Thechallenge />
        <SeeAction />
        <Theplatform />
        <WhoItsFor />
        <TestimonialEms />
        <HowEngage />
        <WhyNube />
        <CTAEms />
        <Footer />
      </>
    );
  }
}
